import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { BaasicTable, Loader, BaasicHeader } from 'core/components';

const CloseOutDetailTemplate = ({
	t,
	closeOutDetailViewStore,
	closeOutDetailViewStore: {
		warehouse,
		tableData,
		fulfillmentOrderStore,
		noDataItem,
		data,
		loading,
		superAdminWarehouse,
		rootStore,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<div className="container--fluid">
			<BaasicHeader rootStore={rootStore} title={'CLOSEOUTDETAILVIEW.LABEL.TITLE'} />
			<div className="order__wrapper">
				<div className="order__header">
					<div className="container--fluid">
						<div className="row">
							<div className="col col-sml-6 col-med-6 col-xlrg-3 col-xxlrg-3 spc--bottom--sml">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">{t('CLOSEOUTDETAILVIEW.LABEL.WAREHOUSE')}</h4>
									<p>
										{warehouse.applicationTitle !== 'SuperAdminOrganization'
											? warehouse.applicationTitle
											: superAdminWarehouse}{' '}
									</p>
								</div>
							</div>
							<div className="col col-sml-6 col-med-6 col-xlrg-3 col-xxlrg-3 spc--bottom--sml">
								<div className="order__header__item">
									<h4 className="order__header__title type--base">{t('CLOSEOUTDETAILVIEW.LABEL.CODE')}</h4>
									<p>
										{warehouse != null && warehouse.warehouseOrganizationInfo != null
											? warehouse.warehouseOrganizationInfo.code
											: ''}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="order__details k-grid--close-out">
				<h4 className="order__box__title order__box__title--table">
					{t('CLOSEOUTDETAILVIEW.LABEL.FULFILLMENTORDERS')}
				</h4>
				<BaasicTable
					{...{
						data: data.item,
						tableData,
						listStore: fulfillmentOrderStore,
						actions: closeOutDetailViewStore,
						noDataItem,
					}}
				/>
			</div>
		</div>
	);
};

export default defaultTemplate(CloseOutDetailTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/modules/order/pages/CloseOutDetailTemplate.jsx